import { track } from "common/utils/mixpanel/tracker";

const WRAPPER_SELECTOR = "#tech-report-troubleshooting-steps";
const YES_SELECTOR = '[data-testid="tech-report-bullets-yes"]';
const NO_SELECTOR = '[data-testid="tech-report-bullets-no"]';

export function attachListeners() {
  const wrapper = document.querySelector(WRAPPER_SELECTOR) as HTMLElement | null;
  if (!wrapper) return;

  // Idempotent guard: this pack is wired to both `DOMContentLoaded` (or
  // synchronously when the DOM is already ready) AND `turbolinks:load`. On a
  // Turbolinks navigation both can fire for the same wrapper instance — without
  // this marker, the click handlers stack and every bullets-resolved /
  // redirected / form_expanded event fires twice. (PR #57544 playwright run-2.)
  if (wrapper.dataset["mxAttached"] === "true") return;
  wrapper.dataset["mxAttached"] = "true";

  const storeCode = wrapper.dataset["storeCode"] || "";

  // The Yes button is a server-rendered <a> (link_to) that navigates the page.
  // Both events fire sendBeacon so they survive the navigation.
  const yesButton = wrapper.querySelector(YES_SELECTOR);
  yesButton?.addEventListener("click", () => {
    track(
      "tech_report_bullets_resolved",
      { resolved: "yes", store_code: storeCode },
      { transport: "sendBeacon", send_immediately: true }
    );
    track(
      "tech_report_redirected",
      { destination: "contactus", store_code: storeCode },
      { transport: "sendBeacon", send_immediately: true }
    );
  });

  // The No button has an inline onclick that calls window.expandTechnicalForm.
  // Our listener fires alongside it (event listeners and inline handlers run
  // independently) so the form still expands while we record the event. No
  // navigation, so no sendBeacon needed.
  const noButton = wrapper.querySelector(NO_SELECTOR);
  noButton?.addEventListener("click", () => {
    track("tech_report_bullets_resolved", { resolved: "no", store_code: storeCode });
    track("tech_report_form_expanded", { store_code: storeCode });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", attachListeners);
} else {
  attachListeners();
}
document.addEventListener("turbolinks:load", attachListeners);
